import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  Stack,
  Paper,
  Typography,
  IconButton,
  Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const DetalleListaDialog = ({ open, onClose, titulo, items = [] }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      // Scrollable para listas muy largas
      scroll="paper" 
    >
      <DialogTitle
        sx={{
          backgroundColor: "#3857a6",
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          fontFamily: "Montserrat-Bold",
          fontSize: "1rem",
          px: 3,
          py: 2,
        }}
      >
        {titulo || "Detalle de información"}
        <IconButton onClick={onClose} sx={{ color: "#fff" }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <Divider />

      <DialogContent sx={{ px: 3, py: 3, backgroundColor: "#f8fafc" }}>
        <Stack spacing={1.5}>
          {items.length > 0 ? (
            items.map((item, index) => (
              <Paper
                key={`${item}-${index}`}
                variant="outlined"
                sx={{
                  px: 2,
                  py: 1.5,
                  borderRadius: 2,
                  borderColor: "rgba(15,23,42,0.1)",
                  backgroundColor: "#fff",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.02)",
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "Montserrat-Regular",
                    fontSize: "0.95rem",
                    color: "#334155",
                    fontWeight: 500
                  }}
                >
                  {item}
                </Typography>
              </Paper>
            ))
          ) : (
            <Typography 
              align="center" 
              sx={{ py: 4, color: "#64748b", fontFamily: "Montserrat-Medium" }}
            >
              No hay información disponible para mostrar.
            </Typography>
          )}
        </Stack>
      </DialogContent>

      <Divider />

      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button
          onClick={onClose}
          variant="contained"
          sx={{
            textTransform: "none",
            fontFamily: "Montserrat-Medium",
            borderRadius: "8px",
            px: 4,
            backgroundColor: "#3857a6",
            boxShadow: "none",
            "&:hover": {
              backgroundColor: "#2f4c98",
              boxShadow: "none",
            },
          }}
        >
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DetalleListaDialog;